export default __webpack_public_path__ + "f62e0305e886035978b4616c874fcf9e.svg";